import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import LineFloatingButton from '../../components/feature/LineFloatingButton';
import BlogHeroSection from './components/BlogHeroSection';
import BlogGrid from './components/BlogGrid';
import SeoHead from '../../components/feature/SeoHead';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const blogJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Blog',
  url: `${SITE_URL}/blog`,
  name: '東京シニア婚活コラム | 縁結び 和はは',
  description: '東京のシニア婚活相談所「縁結び和はは」による婚活東京シニア専門コラム。50代・60代・70代の婚活に役立つ情報や東京シニア婚活のヂントを発信。',
  publisher: {
    '@type': 'Organization',
    name: '縁結び 和はは',
    url: SITE_URL,
    address: {
      '@type': 'PostalAddress',
      addressLocality: '東京都',
      addressCountry: 'JP',
    },
  },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'ホーム', item: SITE_URL },
      { '@type': 'ListItem', position: 2, name: 'コラム', item: `${SITE_URL}/blog` },
    ],
  },
};

export default function BlogPage() {
  return (
    <>
      <SeoHead
        title="東京シニア婚活コラム | 縁結び 和はは"
        description="東京のシニア婚活相談所「縁結び和はは」による婚活東京シニア専門コラム。50代・60代・70代の婚活に役立つ情報を発信。東京シニア婚活のヒント・再婚アドバイス・成婚事例をお届け。"
        keywords="東京 シニア 婚活, 婚活コラム 東京, シニア婚活ヒント, 50代婚活情報, 再婚アドバイス, 60代婚活東京"
        path="/blog"
        jsonLd={blogJsonLd}
      />
      <Navbar />
      <main>
        <BlogHeroSection />
        <BlogGrid />
      </main>
      <Footer />
      <LineFloatingButton />
    </>
  );
}
